import { render, staticRenderFns } from "./MinimalGenericList.vue?vue&type=template&id=70bf28f8&scoped=true&"
import script from "./MinimalGenericList.vue?vue&type=script&lang=ts&"
export * from "./MinimalGenericList.vue?vue&type=script&lang=ts&"
import style0 from "./MinimalGenericList.vue?vue&type=style&index=0&id=70bf28f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf28f8",
  null
  
)

export default component.exports